import { render, staticRenderFns } from "./treeRight.vue?vue&type=template&id=172c467e&scoped=true&"
import script from "./treeRight.vue?vue&type=script&lang=js&"
export * from "./treeRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c467e",
  null
  
)

export default component.exports